import { colorsFoundation } from "./colors-foundation.js";

export const colorsSemantic = {
  text: {
    inverse: colorsFoundation.neutral.white,
    default: colorsFoundation.neutral.softblack,
    disabled: colorsFoundation.neutral[300],
    subtle: colorsFoundation.neutral[700],
    accent: {
      gold: colorsFoundation.key.gold[600],
      blue: colorsFoundation.key.blue[700],
    },
  },
  background: {
    default: colorsFoundation.neutral.white,
    paper: colorsFoundation.neutral.white,
    sidebar: colorsFoundation.neutral[50],
    elevated: colorsFoundation.neutral.white,
    subtle: colorsFoundation.neutral[50],
  },
  border: {
    default: colorsFoundation.neutral[300],
    subtle: colorsFoundation.neutral[200],
    strong: colorsFoundation.neutral[400],
    disabled: colorsFoundation.neutral[200],
    // Legacy nested structure for backward compatibility
    neutral: {
      subtle: colorsFoundation.neutral[300],
      default: colorsFoundation.neutral[400],
      strong: colorsFoundation.neutral[700],
      disabled: colorsFoundation.neutral[200],
    },
    accent: {
      gold: {
        subtle: colorsFoundation.key.gold[300],
        default: colorsFoundation.key.gold[400],
        strong: colorsFoundation.key.gold[600],
      },
    },
  },
  surface: {
    neutral: {
      base: colorsFoundation.neutral.white,
      subtle: colorsFoundation.neutral[100],
    },
    accent: {
      gold: {
        subtlest: colorsFoundation.key.gold[50],
        subtle: colorsFoundation.key.gold[100],
        default: colorsFoundation.key.gold[600],
        strong: colorsFoundation.key.gold[800],
      },
      blue: {
        default: colorsFoundation.key.blue[700],
      },
    },
  },
  icon: {
    default: colorsFoundation.neutral.softblack,
    inverse: colorsFoundation.neutral.white,
    subtle: colorsFoundation.neutral[700],
    disabled: colorsFoundation.neutral[300],
    accent: {
      gold: colorsFoundation.key.gold[600],
      blue: colorsFoundation.key.blue[700],
    },
  },
  label: {
    schaden: {
      gespeichert: colorsFoundation.label.grey,
      entwurf: colorsFoundation.label.grey,
      pruefung: colorsFoundation.label.cyan,
      korrektur: colorsFoundation.label.orange,
      bearbeitung: colorsFoundation.label.yellow,
      abgeschlossen: colorsFoundation.label.blue,
      abgelehnt: colorsFoundation.label.red,
      teilreguliert: colorsFoundation.label.green,
    },
    vertrag: {
      aktiv: colorsFoundation.label.blue,
      archiviert: colorsFoundation.label.grey,
      gekuendigt: colorsFoundation.label.yellow,
    },
    buchung: {
      exportiert: colorsFoundation.label.purple,
      offen: colorsFoundation.label.orange,
      abgeschlossen: colorsFoundation.label.blue,
      freigegeben: colorsFoundation.label.green,
    },
    payment_import: {
      pending: colorsFoundation.label.grey,
      imported: colorsFoundation.label.yellow,
      assigned: colorsFoundation.label.green,
      failed: colorsFoundation.label.red,
    },
    bank_account: {
      active: colorsFoundation.label.green,
      inactive: colorsFoundation.label.grey,
    },
  },
};

export default colorsSemantic;
